/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { Menu, MenuProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

export const useUnitPickerStyles = makeStyles(() => ({
  unitLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
}));

export const StyledMenu = withStyles({
  paper: {
    margin: '8px 0',
    border: '1px solid #EEEEEE',
    backgroundColor: '#FFFFFF',
    borderRadius: '6px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})(
  memo<MenuProps>(props => (
    <Menu
      elevation={0}
      anchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  )),
);
